// extracted by mini-css-extract-plugin
export default {"root":"AndroidGames_root__hia5R","card":"AndroidGames_card__d0vFB"};